import React from 'react';
import PropTypes from 'prop-types';
import { AuthProvider } from '../Auth';
import { IntegrationProvider } from '../Integration';
import { ManagerProvider } from '../Manager';
import { ModalProvider } from '../Modal';
import { PickupProvider } from '../Pickup';
import { StorageProvider } from '../Storage';
import { TrackingProvider } from '../Tracking';
import { WorkflowProvider } from '../Workflow';
import { GlobalProvider } from '../Global';

const Providers = ({ children }) => {
  return (
    <GlobalProvider>
      <AuthProvider>
        <PickupProvider>
          <ModalProvider>
            <ManagerProvider>
              <IntegrationProvider>
                <StorageProvider>
                  <TrackingProvider>
                    <WorkflowProvider>{children}</WorkflowProvider>
                  </TrackingProvider>
                </StorageProvider>
              </IntegrationProvider>
            </ManagerProvider>
          </ModalProvider>
        </PickupProvider>
      </AuthProvider>
    </GlobalProvider>
  );
};

Providers.propTypes = {
  children: PropTypes.node
};

export default Providers;
